module.exports = __webpack_public_path__ + "media/images/healthcare2-f0fd895f83ad0742f3de0d01d346b996.png";